<div class="loader-wrapper" *ngIf="loaderEnabled">
  <div class="backdrop"></div>
  <div class="spinner"></div>
</div>
